import 'proxy-polyfill'
import { PlatformLogger } from '@wix/thunderbolt-symbols'
import { expose } from 'comlink/dist/esm/comlink.js' // eslint-disable-line no-restricted-syntax
import { PlatformClientWorkerAPI } from '../core/types'
import { createCommonWorker } from '../worker-commons/clientWorker'
import { BootstrapData, ViewerAPI } from '../types'
import { siteAssetsClientWorkerAdapter } from './initSiteAssetsClient'
import { fetchModelsFactory } from '../fetchModelsFactory'

const { initPlatformOnSite, runPlatformOnPage: runPlatformOnPageCommonWorker } = createCommonWorker()

function runPlatformOnPage(bootstrapData: BootstrapData, updateProps: ViewerAPI['updateProps'], invokeSdkHandler: ViewerAPI['invokeSdkHandler'], updateStyles: ViewerAPI['updateStyles']) {
	function modelsProviderFactory(logger: PlatformLogger) {
		const siteAssetsClient = siteAssetsClientWorkerAdapter(bootstrapData.platformEnvData, logger)
		return fetchModelsFactory({ siteAssetsClient, bootstrapData, logger })
	}

	return runPlatformOnPageCommonWorker({
		bootstrapData,
		updateProps,
		updateStyles,
		invokeSdkHandler,
		modelsProviderFactory,
	})
}

const platformClientWorkerAPI: PlatformClientWorkerAPI = {
	initPlatformOnSite,
	runPlatformOnPage,
}
expose(platformClientWorkerAPI)
